import $$ from '../core/dom-query.js';

export default class Dropzone {
  constructor(context) {
    this.context = context;
    this.$eventListener = $$(document);
    this.$editor = context.layoutInfo.editor;
    this.$editable = context.layoutInfo.editable;
    this.options = context.options;
    this.lang = this.options.langInfo;
    this.documentEventHandlers = {};

    const dropzoneHtml = [
      '<div class="note-dropzone">',
        '<div class="note-dropzone-message"></div>',
      '</div>',
    ].join('');
    const dropzoneEl = $$.parseHTML(dropzoneHtml)[0];
    this.$dropzone = $$(dropzoneEl);
    this.$editor.prepend(this.$dropzone);
  }

  initialize() {
    if (this.options.disableDragAndDrop) {
      
      this.documentEventHandlers.onDrop = (e) => {
        e.preventDefault();
      };
      
      this.$eventListener = this.$dropzone;
      this.$eventListener.on('drop', this.documentEventHandlers.onDrop);
    } else {
      this.attachDragAndDropEvent();
    }
  }

  attachDragAndDropEvent() {
    let collection = [];
    const $dropzoneMessage = this.$dropzone.find('.note-dropzone-message');

    this.documentEventHandlers.onDragenter = (e) => {
      const isCodeview = this.context.invoke('codeview.isActivated');
      const hasEditorSize = this.$editor.width() > 0 && this.$editor.height() > 0;
      if (!isCodeview && !collection.length && hasEditorSize) {
        this.$editor.addClass('dragover');
        this.$dropzone.width(this.$editor.width());
        this.$dropzone.height(this.$editor.height());
        $dropzoneMessage.text(this.lang.image.dragImageHere);
      }
      if (!collection.includes(e.target)) {
        collection.push(e.target);
      }
    };

    this.documentEventHandlers.onDragleave = (e) => {
      collection = collection.filter(t => t !== e.target);

      if (!collection.length || e.target.nodeName === 'BODY') {
        collection = [];
        this.$editor.removeClass('dragover');
      }
    };

    this.documentEventHandlers.onDrop = () => {
      collection = [];
      this.$editor.removeClass('dragover');
    };

    this.$eventListener.on('dragenter', this.documentEventHandlers.onDragenter)
      .on('dragleave', this.documentEventHandlers.onDragleave)
      .on('drop', this.documentEventHandlers.onDrop);

    this.$dropzone.on('dragenter', () => {
      this.$dropzone.addClass('hover');
      $dropzoneMessage.text(this.lang.image.dropImage);
    }).on('dragleave', () => {
      this.$dropzone.removeClass('hover');
      $dropzoneMessage.text(this.lang.image.dragImageHere);
    });

    this.$dropzone.on('drop', (event) => {
      const dataTransfer = event.dataTransfer;

      event.preventDefault();

      if (dataTransfer && dataTransfer.files && dataTransfer.files.length) {
        this.$editable.focus();
        this.context.invoke('editor.insertImagesOrCallback', dataTransfer.files);
      } else {
        $$.each(dataTransfer.types, (idx, type) => {
          
          if (type.toLowerCase().indexOf('_moz_') > -1) {
            return;
          }
          const content = dataTransfer.getData(type);

          if (type.toLowerCase().indexOf('text') > -1) {
            this.context.invoke('editor.pasteHTML', content);
          } else {
            const nodes = $$.parseHTML(content);
            nodes.forEach((item) => {
              this.context.invoke('editor.insertNode', item);
            });
          }
        });
      }
    }).on('dragover', (e) => { e.preventDefault(); }); 
  }

  destroy() {
    Object.keys(this.documentEventHandlers).forEach((key) => {
      this.$eventListener.off(key.slice(2).toLowerCase(), this.documentEventHandlers[key]);
    });
    this.documentEventHandlers = {};
  }
}